import React from "react";
import Header from "../Header";

export class Layout extends React.Component {
    state = {};

    render() {
        return (
            <>
                <Header />
                <div className="row justify-content-center" style={{ marginTop: '4.5rem' }}>
                    <div className="col-md-11">
                        {this.props.children}
                    </div>
                </div>
            </>
        )
    }
}